export default [
  {
    id: "address_proof",
    title: "Address Proof(Image/Pdf)",
    type: "fileUpload",
    file_type: "address_proof",
    required: true,
    fontColor: "#ffffff",
  },
  {
    id: "id_proof",
    title: "ID Proof(Image/Pdf)",
    type: "fileUpload",
    file_type: "id_proof",
    required: true,
    fontColor: "#ffffff",
  },
  {
    id: "PAN_proof",
    title: "PAN Card(Image/Pdf)",
    type: "fileUpload",
    file_type: "pan",
    required: true,
    fontColor: "#ffffff",
  },
  {
    id: "GST_proof",
    title: "GSTIN Certificate(Image/Pdf)",
    type: "fileUpload",
    file_type: "gst",
    required: false,
    fontColor: "#ffffff",
  },
];
